import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=6cbdb574&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "@/assets/home.scss?vue&type=style&index=0&id=6cbdb574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbdb574",
  null
  
)

export default component.exports